// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"29586c2b","457":"854803aa"}[chunkId] + ".chunk.js";
};